export default "__VITE_ASSET__CPux1R0k__"